import React from 'react'
import VocoContext from '../contexts/VocoContext'
import _ from 'lodash'
import Container from 'react-bootstrap/Container'

export default class CopyClipboardContainer extends React.Component {
    static contextType = VocoContext
    
    constructor(props, context) {
        super(props, context)
        this.subPackageRef = React.createRef()
    }
    
    componentDidMount(){
        let subPackage = this.context.config.subPackageConfig.subPackage
        let configOutcome = this.context.config.subPackageConfig.outcomesSubPackage.outcomes
        let defaultObjectToBeCopiedToClipboard = this.context.config.subPackageConfig.outcomesSubPackage.default
        let message = this.context.message
        
        let embedContent = this.context.ioc.injectWithModules(["3r/message-api/content/embedMessageContent"], function(embedMessageContent, text){
            return embedMessageContent(message, {}, text)     
        }) 
        
        let subPackageModules = {}
        subPackageModules = this.copyObj(subPackageModules, this.context.fullModules)
        subPackageModules.device = _.cloneDeep(this.context.device)
        subPackageModules.device.copyClipboardParentTriggerOutcome = subPackageModules.device.triggerOutcome
        subPackageModules.parent = { message : this.contextmessage }
        
        subPackageModules.device.triggerOutcome = function (outcome, isFinal) {
            console.log('DEBUG: device.triggerOutcome : ', outcome, ':', isFinal)
            let outcomeIndex = _.findIndex(configOutcome, (c) => { 
                return c.isOutcome.toLowerCase().trim() == outcome.toLowerCase().trim()
            })
            let clipboardText = ''
            let popupUrl = ''
            
            if (isFinal && outcomeIndex >= 0) {
                clipboardText = (configOutcome[outcomeIndex] || {}).clipboardText
                if(clipboardText){
                    copyToClipboard(embedContent(clipboardText))
                    console.log(clipboardText, ' has been copied to clipboard')
                }
                popupUrl = (configOutcome[outcomeIndex] || {}).popupUrl
                if(popupUrl){
                    openUrl(popupUrl)
                    console.log(popupUrl, ' has been opened')
                }
            } else {
                clipboardText = defaultObjectToBeCopiedToClipboard.clipboardText
                if(clipboardText){
                    copyToClipboard(embedContent(clipboardText))
                    console.log(clipboardText, ' has been copied to clipboard')
                }
                popupUrl = defaultObjectToBeCopiedToClipboard.popupUrl
                if(popupUrl){
                    openUrl(popupUrl)
                    console.log(popupUrl, ' has been opened')
                }
            }
            let triggerOutcomeResult = this.copyClipboardParentTriggerOutcome(outcome, isFinal)
            return triggerOutcomeResult
        }
        
        let copyToClipboard = (dataToCopy) => {
            let tmp = document.createElement("input")
            tmp.setAttribute("value", dataToCopy)
            document.body.appendChild(tmp)
            tmp.select()
            document.execCommand("copy")
            document.body.removeChild(tmp)
        }
            
        let openUrl = (popupUrl) => {
            window.open(popupUrl)
        }
        
        subPackage(subPackageModules , null , this.subPackageRef.current)
    }
    
    copyObj (to, from) {
        for (let k in from) {
            if (from.hasOwnProperty(k)) {
                to[k] = from[k]
            }
        }
        return to
    }
    
    render() {
        let message = this.context.message || {}
        return <Container ref={this.subPackageRef} id={"copyClipboardContainerPackage" + message.systemId} className="copyClipboardContainerPackage">
                Sub package will load here
        </Container>
    }
    
}
